import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
AOS.init();


axios.defaults.baseURL = 'https://dgatewayinbackend.dgatewayin.com';
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
